import { render, staticRenderFns } from "./UpdateCabinetJuridique.vue?vue&type=template&id=e398c962&"
import script from "./UpdateCabinetJuridique.vue?vue&type=script&lang=js&"
export * from "./UpdateCabinetJuridique.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCabinetJuridique.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports